const normalize = value => String(value || '').toLocaleLowerCase('tr-TR');
function friendActionState(social = {}, me, target) {
  const other = normalize(target);
  const contains = values => (values || []).some(value => normalize(value) === other);
  if (!other || other === normalize(me) || other === 'bilgisayar') return { label: '', disabled: true };
  if (contains(social.blocked)) return { label: 'Engellenmiş', disabled: true };
  if (contains(social.friends)) return { label: 'Arkadaşın', disabled: true };
  if ((social.incoming || []).some(item => normalize(item.from) === other)) return { label: 'İsteği kabul et', action: 'accept' };
  if ((social.outgoing || []).some(item => normalize(item.to) === other)) return { label: 'İstek gönderildi', disabled: true };
  return { label: 'Arkadaş ekle', action: 'request' };
}
function rematchDefaults(data = {}) {
  return { boardSize: [5, 8].includes(data.boardSize) ? data.boardSize : 5,
    preset: data.clockSpec?.version === 2 && ['10+0', '30+0', '12h'].includes(data.clockSpec.preset) ? data.clockSpec.preset : [12, 72].includes(data.turnDurationHours) ? 'legacy' : '30+0' };
}
function rematchMessage(target, options, data = {}) {
  if (!target || ![5, 8].includes(options.boardSize)) throw Error('Geçerli rakip ve tahta boyutu seç.');
  const message = normalize(target) === 'bilgisayar'
    ? { type: 'startBotGame', botDifficulty: options.botDifficulty ?? data.botDifficulty, boardSize: options.boardSize }
    : { type: 'invite', to: target, fromRematch: true, boardSize: options.boardSize };
  if(message.type==='startBotGame' && !Number.isInteger(message.botDifficulty)) throw Error('Önceki maçın seviyesi kayıtlı değil. Yeni maç için seviye seç.');
  if(options.matchKind!=null&&!['single','duel'].includes(options.matchKind))throw Error('Geçersiz maç türü.');
  if(message.type==='invite'){message.matchKind='single';message.matchMode=options.boardSize===8?'casual':options.matchMode||'casual';}
  if (options.preset === 'legacy' && [12, 72].includes(data.turnDurationHours)) message.turnDurationHours = data.turnDurationHours;
  else if (['10+0', '30+0', '12h'].includes(options.preset)) message.clockPreset = options.preset;
  else throw Error('Geçerli süre seç.');
  return message;
}
module.exports = { friendActionState, rematchDefaults, rematchMessage };
